export default __webpack_public_path__ + "static/media/shareInsta.15f2afae.svg";